import { useNavigate } from 'react-router-dom';
import { EmptyState } from '@/components/custom/empty-state';
import { UserInfo } from '@/components/custom/user';
import { Loader } from '@/components/custom/loader';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { FiChevronLeft, FiInfo } from 'react-icons/fi';
import { DashboardContent } from '@/layouts/dashboard';

export default function ViewImports(props) {
  const navigate = useNavigate();
  const { importId } = props;
  const client = useClient();
  const [spreadsheetImport, setSpreadsheetImport] = useState([]);
  const [loading, setLoading] = useState(true);

  const getSpredsheetImport = async () => {
    const { data, error } = await client.fetch(`spreadsheet_imports/${importId}`);
    if (error) {
      toast.error('Erro ao buscar informações da importação');
    } else {
      setSpreadsheetImport(data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getSpredsheetImport();
  }, [importId]);

  return (
    <DashboardContent variant="plain">
      <div className="filter-bar">
        <div className="filter-bar__inner">
          <button
            className="filter-bar__back"
            onClick={() => navigate(-1)}
          >
            <span className="card__icon-wrapper">
              <FiChevronLeft className="card__icon" />
            </span>
            <span className="filter-bar__back-container">
              <span className="filter-bar__title">{spreadsheetImport?.filename}</span>
            </span>
          </button>
        </div>
      </div>
      {loading && <Loader />}
      {!loading && spreadsheetImport.users.length === 0 && spreadsheetImport.status === 'import_success' && <EmptyState type="data" />}
      {!loading && spreadsheetImport.status === 'import_failed' && (
        <>
          <h2 className="modal__simple-title">{t('classes.errosDetailsTitle')}</h2>
          <p className="form__description mb-6 text-sm">{t('classes.errorDetailsDescription')}</p>
          <table className="round-dg round-dg--light">
            <thead className="round-dg__header">
              <tr className="round-dg__row">
                <th className="round-dg__cell-header w-16">{t('textsCommon.item')}</th>
                <th className="round-dg__cell-header w-32">{t('textsCommon.rowInTable')}</th>
                <th className="round-dg__cell-header">{t('textsCommon.reason')}</th>
              </tr>
            </thead>

            <tbody className="round-dg__body">
              {spreadsheetImport?.['import-errors']?.map((error, index) => (
                <tr
                  className="round-dg__row"
                  key={index}
                >
                  <td className="round-dg__cell text-bold font-bold text-primary-dark">#{index + 1}</td>
                  <td className="round-dg__cell">{error.line || '--'}</td>
                  <td className="round-dg__cell">{error.message || '--'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {!loading && spreadsheetImport.status === 'import_created' && (
        <div
          className="card card--simple"
          style={{ width: 'fit-content', margin: '0 auto' }}
        >
          <span>Processamento da planilha em andamento...</span>
        </div>
      )}
      {!loading && spreadsheetImport.users.length > 0 && (
        <table className="round-dg round-dg--light">
          <thead className="round-dg__header">
            <tr className="round-dg__row">
              <th className="round-dg__cell-header">{t('textsCommon.name')}</th>
              <th className="round-dg__cell-header">{t('profile.labelPhone')}</th>
              <th className="round-dg__cell-header">{t('textsCommon.class')}</th>
              <th
                className="round-dg__cell-header"
                style={{ width: '160px' }}
              >
                {t('journey.thLastAccess')}
              </th>
            </tr>
          </thead>

          <tbody className="round-dg__body">
            {spreadsheetImport?.users?.map((user, index) => (
              <tr
                className="round-dg__row"
                key={index}
              >
                <th className="round-dg__cell-header round-dg__cell-header--row">
                  <UserInfo
                    user={user}
                    viewEmail
                  />
                </th>
                <td className="round-dg__cell">{user.phone}</td>
                <td className="round-dg__cell">{spreadsheetImport?.classroom?.title}</td>
                {user['last_access'] !== null && <td className="round-dg__cell">{moment(user['last_access']).format('DD/MM/YYYY')}</td>}
                {user['last_access'] === null && (
                  <td className="round-dg__cell">
                    <span className="badge badge--tiny badge--warning">{t('participants.tagRegistrationSent')}</span>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DashboardContent>
  );
}
